import { createAsyncThunk } from '@reduxjs/toolkit';

import { nifsAxios } from 'constants/axios';
import { networkActions } from 'features/network/networkSlice';
import MatchEvent from 'interfaces/matchEvent';
import NetworkStatus from 'enums/networkStatus';

import { deleteMatchEvent, patchMatchEvent, postMatchEvent } from 'features/match/thunks';
import { MatchEventStatus } from '../../enums/matchEventStatus';
import { MatchEventType } from '../../enums/matchEventType';

export const getNetworkStatus = createAsyncThunk('network/getNetworkStatus', async (payload, { dispatch }) => {
  try {
    await nifsAxios.get('/health');
    dispatch(networkActions.setStatus(NetworkStatus.UP));
    return { status: NetworkStatus.UP };
  } catch {
    dispatch(networkActions.setStatus(NetworkStatus.DOWN));
    return { status: NetworkStatus.DOWN };
  }
});

export const retryErrorEvents = createAsyncThunk(
  'network/retryErrorEvents',
  async (matchEvents: Array<MatchEvent>, thunkAPI) => {
    //@TODO: add others
    const eventTypeIdOrder = [
      MatchEventType.GOAL,
      MatchEventType.OWN_GOAL,
      MatchEventType.DISALLOWED_GOAL,
      MatchEventType.ASSIST,
      MatchEventType.INDIRECT_ASSIST,
    ];
    matchEvents.sort((a, b) => {
      return eventTypeIdOrder.indexOf(a.matchEventTypeId) - eventTypeIdOrder.indexOf(b.matchEventTypeId);
    });
    const { dispatch } = thunkAPI;
    try {
      for (let i = 0; i < matchEvents.length; i++) {
        const matchEvent: MatchEvent = {
          comment: matchEvents[i].comment,
          id: matchEvents[i].id,
          internal: matchEvents[i].internal,
          important: matchEvents[i].important,
          liveFeedId: matchEvents[i].liveFeedId,
          liveFeedSerialId: matchEvents[i].liveFeedSerialId,
          matchEventTypeId: matchEvents[i].matchEventTypeId,
          matchId: matchEvents[i].matchId,
          overtime: matchEvents[i].overtime,
          person: matchEvents[i].person,
          periodId: matchEvents[i].periodId,
          score: matchEvents[i].score,
          seconds: matchEvents[i].seconds,
          sorting: matchEvents[i].sorting,
          sportId: matchEvents[i].sportId,
          team: matchEvents[i].team,
          time: matchEvents[i].time,
          timestamp: matchEvents[i].timestamp,
          isStaffEvent: matchEvents[i].isStaffEvent,
        };
        if (matchEvent?.id) {
          if (matchEvent.internal?.status === MatchEventStatus.ERROR) {
            await dispatch(patchMatchEvent(matchEvent));
          } else if (matchEvent.internal) {
            await dispatch(deleteMatchEvent(matchEvent));
          }
        } else {
          await dispatch(postMatchEvent(matchEvent));
        }
      }
    } catch {}
  },
);
